import { resolvePageObjectMaskSource } from '@sosocio/tools/page-object-mask';
import brush from '../../img/masks/brush.svg';
import cloud from '../../img/masks/cloud.svg';
import clover from '../../img/masks/clover.svg';
import diamond from '../../img/masks/diamond.svg';
import flower from '../../img/masks/flower.svg';
import heart from '../../img/masks/heart.svg';
import octagon from '../../img/masks/octagon.svg';
import square from '../../img/masks/square.svg';
import stamp from '../../img/masks/stamp.svg';
import star from '../../img/masks/star.svg';

/*
 * IMPORTANT: When adding SVG masks, make sure the SVG has the properties
 * "preserveAspectRatio: none", "width", and "height" defined
 * Otherwise Firefox will run into problems displaying them
 */

const maskPresets: {
	[key: string]: {
		src: string;
		lockAspectRatio: boolean;
	};
} = {
	brush: {
		src: brush,
		lockAspectRatio: false,
	},
	circle: {
		src: resolvePageObjectMaskSource('circle')!,
		lockAspectRatio: false,
	},
	circleLocked: {
		src: resolvePageObjectMaskSource('circleLocked')!,
		lockAspectRatio: true,
	},
	cloud: {
		src: cloud,
		lockAspectRatio: false,
	},
	clover: {
		src: clover,
		lockAspectRatio: true,
	},
	diamond: {
		src: diamond,
		lockAspectRatio: false,
	},
	flower: {
		src: flower,
		lockAspectRatio: true,
	},
	heart: {
		src: heart,
		lockAspectRatio: true,
	},
	octagon: {
		src: octagon,
		lockAspectRatio: false,
	},
	squareLocked: {
		src: square,
		lockAspectRatio: true,
	},
	stamp: {
		src: stamp,
		lockAspectRatio: false,
	},
	star: {
		src: star,
		lockAspectRatio: true,
	},
};

export default maskPresets;

/**
 * Resolves a persisted `mask` value to the config used to load/composite it.
 *
 * Values that aren't a known preset key (e.g. a custom mask URL supplied by
 * a template position) are treated as a direct image source.
 *
 * @param mask Persisted mask identifier or custom mask URL.
 * @returns Mask source and aspect-ratio lock to use for loading/compositing.
 */
export function resolveMaskSource(mask: string): {
	src: string;
	lockAspectRatio: boolean;
} {
	return maskPresets[mask] ?? {
		src: mask,
		lockAspectRatio: false,
	};
}

/**
 * Whether a persisted `mask` value is a custom mask (not a known preset
 * key), e.g. a URL supplied by a template position.
 *
 * @param mask Persisted mask identifier or custom mask URL.
 * @returns Whether the value should be treated as a custom mask source.
 */
export function isCustomMask(mask?: string | null): boolean {
	if (
		!mask
		|| mask === 'none'
		|| mask === 'square'
	) {
		return false;
	}

	return !(mask in maskPresets);
}
